interface IMessageBoxProps {
  message: string;
  type?: "success" | "error";
}

export default function MessageBox({
  message,
  type = "success",
}: IMessageBoxProps) {
  const isError = type === "error";

  return (
    <div
      role="alert"
      className={`alert d-flex ${
        isError ? "bgc-red-l4 brc-red-m4" : "bgc-green-l4 brc-green-m4"
      } border-1 pl-3 radius-l-0 col-12`}
    >
      <div
        className={`position-tl h-102 border-l-4 ${
          isError ? "brc-red" : "brc-green"
        } mt-n1px`}
      />
      <span className={isError ? "text-red-d2" : "text-green-d2"}>
        <pre style={{ whiteSpace: "pre-wrap" }} className="p-10">
          {message}
        </pre>
      </span>
    </div>
  );
}
